// extracted by mini-css-extract-plugin
module.exports = {"scanImg":"expense-form_scanImg_2ggVE","clearButtonContainer":"expense-form_clearButtonContainer_21ax_"};